import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface PopUpResult {
  canceled: boolean
  confirmed: boolean
}

@Component({
  selector: 'app-pop-up-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="modal-title">{{'redesign.wrongDoorTypeSelection.title' | translate }}</h4>
    </div>
    <div class="modal-body">{{'redesign.wrongDoorTypeSelection.message' | translate }}</div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" (click)="confirm()">
        {{'redesign.wrongDoorTypeSelection.continueAnyway' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="cancel()">
        {{'redesign.wrongDoorTypeSelection.back' | translate }}</button>
    </div>
  `
})
export class PopUpComponent {
  constructor(public activeModal: NgbActiveModal) {}

  private closeModal(result: PopUpResult): void {
    this.activeModal.close(result);
  }

  confirm() {
    this.closeModal({
      canceled: false,
      confirmed: true
    })
  }

  cancel() {
    this.closeModal({
      canceled: true,
      confirmed: false
    })
  }
}
